import { render } from "./inbox-overview.vue?vue&type=template&id=0178f024"
import script from "./inbox-overview.vue?vue&type=script&lang=js"
export * from "./inbox-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__